import { Box, Grid, Skeleton } from "@mui/material";
import React from "react";

export default function WithdrawFormSkeleton() {
  return (
    <Grid container>
      <Grid xs={12} item>
        <Box py={1}>
          <Skeleton variant="rounded" height={10} width="20%"></Skeleton>
        </Box>

        <Box>
          <Skeleton variant="rounded" height={40} width="100%"></Skeleton>
        </Box>

        <Box py={1}>
          <Skeleton variant="rounded" height={10} width="25%"></Skeleton>
        </Box>

        <Box>
          <Skeleton variant="rounded" height={40} width="100%"></Skeleton>
        </Box>

        <Box py={1}>
          <Skeleton variant="rounded" height={10} width="30%"></Skeleton>
        </Box>

        <Box>
          <Skeleton variant="rounded" height={40} width="100%"></Skeleton>
        </Box>

        <Box py={1}>
          <Skeleton variant="rounded" height={10} width="40%"></Skeleton>
        </Box>

        <Box>
          <Skeleton variant="rounded" height={40} width="100%"></Skeleton>
        </Box>

        <Box pt={2}>
          <Skeleton variant="rounded" height={10} width="60%"></Skeleton>
        </Box>

        <Box pt={1}>
          <Skeleton variant="rounded" height={10} width="30%"></Skeleton>
        </Box>

        <Box pt={1}>
          <Skeleton variant="rounded" height={10} width="40%"></Skeleton>
        </Box>

        <Box pt={2}>
          <Skeleton variant="rounded" height={10} width="40%"></Skeleton>
        </Box>

        <Box pt={2}>
          <Skeleton variant="rounded" height={10} width="60%"></Skeleton>
        </Box>

        <Box pt={2}>
          <Skeleton variant="rounded" height={40} width="100%"></Skeleton>
        </Box>
      </Grid>
    </Grid>
  );
}
